
































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import { cloneDeep } from 'lodash';
import { toUpperCase } from '@/helpers/toUpperCase';

@Component
export default class clientUnitDepartamentForm extends BaseComponent {
  @Prop()
  public isEdit: boolean = false;
  @Prop()
  public editItem: any;

  public form: any = {
    valid: false,
    rules: {
      name: [(v) => !!v || 'Digite o nome'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public item: any = {
    nome: '',
  };

  @Watch('editItem')
  public onEditItemChanges(val: any) {
    this.item = {
      id: null,
      nome: '',
    };
    this.$refs.form.resetValidation();
    if (!val) {
      return;
    }

    this.item = cloneDeep(val);
  }

  public beforeMount() {
    this.item = {
      nome: '',
    };
  }

  public saveItem(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }
    if (!this.item.id) {
      const uuidv4 = require('uuid/v4');
      this.item.id = uuidv4();
      this.item.new = true;
    } else {
      this.item.new = false;
    }

    this.item.nome = toUpperCase(this.item.nome);

    const payload = cloneDeep(this.item); // Clones the Model into the Payload
    this.$emit('save', payload);
    this.$refs.form.resetValidation();
  }

  public closeForm(): void {
    const closeAction = () => {
      setTimeout(() => {
        this.$refs.form.resetValidation();
      }, 100);
      this.$emit('close');
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }
}
